__turbopack_context__.v({
  "active": "SlateEditor-module__YvnXAG__active",
  "ai-input": "SlateEditor-module__YvnXAG__ai-input",
  "bottom": "SlateEditor-module__YvnXAG__bottom",
  "brushing": "SlateEditor-module__YvnXAG__brushing",
  "editor-area-container": "SlateEditor-module__YvnXAG__editor-area-container",
  "editor-audio-block": "SlateEditor-module__YvnXAG__editor-audio-block",
  "editor-block-mask": "SlateEditor-module__YvnXAG__editor-block-mask",
  "editor-button": "SlateEditor-module__YvnXAG__editor-button",
  "editor-button-group": "SlateEditor-module__YvnXAG__editor-button-group",
  "editor-button-seperator": "SlateEditor-module__YvnXAG__editor-button-seperator",
  "editor-context-menu": "SlateEditor-module__YvnXAG__editor-context-menu",
  "editor-context-menu-item": "SlateEditor-module__YvnXAG__editor-context-menu-item",
  "editor-image-block": "SlateEditor-module__YvnXAG__editor-image-block",
  "editor-image-operations-trigger": "SlateEditor-module__YvnXAG__editor-image-operations-trigger",
  "editor-link-input-container": "SlateEditor-module__YvnXAG__editor-link-input-container",
  "editor-mobile-link-input-modal": "SlateEditor-module__YvnXAG__editor-mobile-link-input-modal",
  "editor-mobile-upward-menu": "SlateEditor-module__YvnXAG__editor-mobile-upward-menu",
  "editor-video-block-tool": "SlateEditor-module__YvnXAG__editor-video-block-tool",
  "first-blockquote": "SlateEditor-module__YvnXAG__first-blockquote",
  "focused": "SlateEditor-module__YvnXAG__focused",
  "header": "SlateEditor-module__YvnXAG__header",
  "hyperlink-input": "SlateEditor-module__YvnXAG__hyperlink-input",
  "hyperlink-target-blank-button": "SlateEditor-module__YvnXAG__hyperlink-target-blank-button",
  "icon": "SlateEditor-module__YvnXAG__icon",
  "inline-toolbar": "SlateEditor-module__YvnXAG__inline-toolbar",
  "items-container": "SlateEditor-module__YvnXAG__items-container",
  "middle-blockquote": "SlateEditor-module__YvnXAG__middle-blockquote",
  "mobile-toolbar-container": "SlateEditor-module__YvnXAG__mobile-toolbar-container",
  "no-arrow": "SlateEditor-module__YvnXAG__no-arrow",
  "richtext-highlight-text": "SlateEditor-module__YvnXAG__richtext-highlight-text",
  "richtext-slashInput": "SlateEditor-module__YvnXAG__richtext-slashInput",
  "seperator": "SlateEditor-module__YvnXAG__seperator",
  "show-ai-placeholder": "SlateEditor-module__YvnXAG__show-ai-placeholder",
  "show-ai-slashMenu-placeholder": "SlateEditor-module__YvnXAG__show-ai-slashMenu-placeholder",
  "show-block-placeholder": "SlateEditor-module__YvnXAG__show-block-placeholder",
  "show-slash-placeholder": "SlateEditor-module__YvnXAG__show-slash-placeholder",
  "slate-edit-area": "SlateEditor-module__YvnXAG__slate-edit-area",
  "slate-editor": "SlateEditor-module__YvnXAG__slate-editor",
  "todo-list-item": "SlateEditor-module__YvnXAG__todo-list-item",
  "toolbar-content": "SlateEditor-module__YvnXAG__toolbar-content",
  "toolbar-override": "SlateEditor-module__YvnXAG__toolbar-override",
  "top-toolbar": "SlateEditor-module__YvnXAG__top-toolbar",
  "up": "SlateEditor-module__YvnXAG__up",
  "upward-menu-item": "SlateEditor-module__YvnXAG__upward-menu-item",
  "with-brick-toolbar": "SlateEditor-module__YvnXAG__with-brick-toolbar",
});
